import React from 'react';
import { Package, AlertCircle, CheckCircle, ClipboardCheck } from 'lucide-react';

export default function StatsCards({ counts }) {
  const stats = [
    {
      label: 'Total',
      value: counts.total,
      icon: Package,
      iconColor: 'text-locate2-primary',
      bgColor: 'bg-status-info-bg',
    },
    {
      label: 'Needs Action',
      value: counts.needsAction,
      icon: AlertCircle,
      iconColor: 'text-status-error',
      bgColor: 'bg-status-error-bg',
    },
    {
      label: 'Completed',
      value: counts.completed,
      icon: CheckCircle,
      iconColor: 'text-status-success',
      bgColor: 'bg-status-success-bg',
    },
    {
      label: 'Actioned',
      value: counts.actioned,
      icon: ClipboardCheck,
      iconColor: 'text-locate2-primary',
      bgColor: 'bg-status-info-bg',
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 mb-6">
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <div
            key={stat.label}
            className="bg-white rounded-xl border border-locate2-border-light p-3 sm:p-4 transition-shadow hover:shadow-sm"
          >
            <div className="flex items-center gap-2 sm:gap-3">
              <div
                className={`w-9 h-9 sm:w-11 sm:h-11 rounded-lg ${stat.bgColor} flex items-center justify-center flex-shrink-0`}
              >
                <Icon size={18} className={`${stat.iconColor} sm:w-5 sm:h-5`} />
              </div>
              <div>
                <p className="text-lg sm:text-2xl font-bold text-locate2-dark-blue leading-tight">
                  {stat.value}
                </p>
                <p className="text-locate2-light-gray text-[10px] sm:text-xs whitespace-nowrap">{stat.label}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
